export default __webpack_public_path__ + "static/media/certificateSmall.93dcffed.webp";